<template>
  <path d="M13.75 13.035a1 1 0 0 1-1.577.817L5.04 8.817a1 1 0 0 1 0-1.634l7.133-5.035a1 1 0 0 1 1.577.817v10.07z" />
  <path d="M1.75 13.25a.75.75 0 0 0 1.5 0V2.75a.75.75 0 0 0-1.5 0v10.5z" />
</template>
